export const sq: Record<string, string> = {
  'app.title': 'Selektiraj Otpad',
  'app.subtitle': 'Paneli i administrimit',

  'nav.group.operations': 'Operacione',
  'nav.group.catalog': 'Të dhëna bazë',
  'nav.group.rewards': 'Shpërblime',
  'nav.group.system': 'Sistemi',
  'nav.dashboard': 'Pasqyra',
  'nav.appointments': 'Mbledhja e qeseve',
  'nav.bags': 'Kërkesa për qese',
  'nav.schedules': 'Terminet',
  'nav.municipalities': 'Komunat',
  'nav.regions': 'Rajonet',
  'nav.companies': 'Kompanitë',
  'nav.recycleTypes': 'Llojet e mbeturinave',
  'nav.users': 'Përdoruesit',
  'nav.rewards': 'Pikët dhe pagesat',
  'nav.prizeBudgets': 'Buxheti i çmimeve',
  'nav.smartBins': 'Kontejnerë smart',
  'nav.qrCodes': 'Kodet QR',
  'nav.audit': 'Ditari i ndryshimeve',

  'common.save': 'Ruaj',
  'common.cancel': 'Anulo',
  'common.delete': 'Fshi',
  'common.edit': 'Ndrysho',
  'common.create': 'Shto',
  'common.close': 'Mbyll',
  'common.search': 'Kërko',
  'common.actions': 'Veprime',
  'common.yes': 'Po',
  'common.no': 'Jo',
  'common.confirmDelete': 'A jeni i sigurt që doni ta fshini këtë regjistrim?',
  'common.saved': 'U ruajt.',
  'common.deleted': 'U fshi.',
  'common.error': 'Ndodhi një gabim. Provoni përsëri.',
  'common.offline': 'Serveri nuk është i arritshëm.',
  'common.loading': 'Duke u ngarkuar…',
  'common.noData': 'Nuk ka të dhëna.',
  'common.refresh': 'Rifresko',
  'common.all': 'Të gjitha',
  'common.logout': 'Dil',
  'common.language': 'Gjuha',
  'common.theme': 'Temë e errët/e çelët',
  'common.details': 'Detaje',
  'common.from': 'Nga',
  'common.to': 'Deri',
  'common.total': 'Gjithsej',
  'common.required': 'Fushë e detyrueshme',
  'common.copy': 'Kopjo',
  'common.copied': 'U kopjua.',
  'common.tableView': 'Tabela',

  'login.title': 'Hyrja',
  'login.email': 'Email',
  'login.password': 'Fjalëkalimi',
  'login.submit': 'Hyr',
  'login.forgot': 'Keni harruar fjalëkalimin?',
  'login.forgotSent': 'Nëse ekziston një llogari me këtë email, dërguam një lidhje për rivendosje.',
  'login.forgotHint': 'Shkruani emailin më lart dhe klikoni përsëri.',

  'reset.title': 'Fjalëkalim i ri',
  'reset.newPassword': 'Fjalëkalimi i ri',
  'reset.hint': 'Të paktën 8 karaktere, një shkronjë dhe një shifër.',
  'reset.submit': 'Vendos fjalëkalimin',
  'reset.done': 'Fjalëkalimi u ndryshua. Ju lutemi hyni.',

  'noAccess.title': 'Pa qasje',
  'noAccess.text': 'Llogaria juaj nuk ka leje për panelin e administrimit. Përdorni aplikacionin celular.',

  'field.name': 'Emri',
  'field.regionCode': 'Kodi i rajonit',
  'field.languageCode': 'Gjuha',
  'field.dateFormat': 'Formati i datës',
  'field.timeFormat': 'Formati i orës',
  'field.currencyCode': 'Monedha',
  'field.currencySymbol': 'Simboli i monedhës',
  'field.region': 'Rajoni',
  'field.isSpecial': 'Lokacion i veçantë (kompani)',
  'field.isGlobal': 'Njofto të gjithë anëtarët',
  'field.showSmartBins': 'Kontejnerë smart',
  'field.allowAwards': 'Shpërblime',
  'field.allowDashboard': 'Pasqyra',
  'field.active': 'Aktive',
  'field.municipalities': 'Komunat',
  'field.color': 'Ngjyra',
  'field.labelHint': 'Etiketa në aplikacion',
  'field.showInApp': 'Shfaq në aplikacion',
  'field.allowedForbidden': 'Përshkrim i lejuar/i ndaluar',
  'field.titleAllowed': 'Titulli 1',
  'field.allowed': 'Teksti 1',
  'field.titleForbidden': 'Titulli 2',
  'field.forbidden': 'Teksti 2',
  'field.titleRules': 'Titulli 3',
  'field.rules': 'Teksti 3',
  'field.image': 'Imazhi',
  'field.date': 'Data',
  'field.hourFrom': 'Nga ora',
  'field.hourTo': 'Deri në orën',
  'field.municipality': 'Komuna',
  'field.location': 'Lokacioni',
  'field.latitude': 'Gjerësia gjeografike',
  'field.longitude': 'Gjatësia gjeografike',
  'field.email': 'Email',
  'field.fullName': 'Emri dhe mbiemri',
  'field.role': 'Roli',
  'field.company': 'Kompania',
  'field.address': 'Adresa',
  'field.phone': 'Telefoni',
  'field.password': 'Fjalëkalimi',
  'field.allowQuality': 'Mund të shënojë cilësinë e mbeturinave',
  'field.status': 'Statusi',
  'field.code': 'Kodi',
  'field.codeKind': 'Lloji i kodit',
  'field.recycleType': 'Lloji i mbeturinave',
  'field.collectorKg': 'Kg (mbledhësi)',
  'field.companyKg': 'Kg (kompania)',
  'field.points': 'Pikë',
  'field.quality': 'Cilësia',
  'field.user': 'Përdoruesi',
  'field.amount': 'Shuma (den.)',
  'field.note': 'Shënim',
  'field.prizeType': 'Çmimi',
  'field.dateFrom': 'Vlen nga',
  'field.dateTo': 'Vlen deri',
  'field.numberOfPrizes': 'Numri i çmimeve',
  'field.winningsInPeriod': 'Fitime për periudhë',
  'field.periodDays': 'Periudha (ditë)',
  'field.numberOfWinnings': 'Fituar deri tani',
  'field.title': 'Emri',
  'field.progress': 'Mbushja',
  'field.lastReport': 'Raporti i fundit',
  'field.createdAt': 'Krijuar',
  'field.balance': 'Pikët aktuale',
  'field.earned': 'Gjithsej të fituara',
  'field.spent': 'Të shpenzuara',
  'field.bags': 'Qese',
  'field.rank': 'Renditja',
  'field.kg': 'Kg',
  'field.count': 'Numri',
  'field.action': 'Veprimi',
  'field.actor': 'Përdoruesi',
  'field.entity': 'Regjistrimi',
  'field.ip': 'Adresa IP',
  'field.type': 'Lloji',
  'field.scheduledFor': 'Termini',
  'field.firstScan': 'Skanimi i parë',
  'field.confirmedAt': 'Konfirmuar',

  'role.Admin': 'Administrator',
  'role.SubAdmin': 'Nën-administrator',
  'role.User': 'Qytetar',
  'role.Collector': 'Mbledhës',
  'role.SuperUserCollector': 'Mbledhës kryesor',
  'role.Company': 'Kompani',
  'role.SunilensSpecialAdmin': 'Administrator i veçantë',

  'status.0': 'Te përdoruesi',
  'status.1': 'Te mbledhësi',
  'status.2': 'Mbërriti në kompani',
  'status.3': 'Dështoi',
  'status.4': 'Te mbledhësi (status)',
  'quality.clean': 'Mbeturina të pastra',
  'quality.contaminated': 'Mbeturina të papastra',
  'quality.none': 'Pa vlerësim',
  'codeKind.standard': 'Standard',
  'codeKind.special': 'I veçantë (i ripërdorshëm)',
  'bagStatus.0': 'E hapur',
  'bagStatus.1': 'Dorëzuar',

  'prize.-1': 'Rrotullim bonus',
  'prize.0': 'Pa çmim',
  'prize.5': '5 pikë',
  'prize.10': '10 pikë',
  'prize.15': '15 pikë',
  'prize.20': '20 pikë',
  'prize.500': '500 denarë',
  'prize.1000': '1000 denarë',
  'prize.2000': '2000 denarë',
  'prize.3000': '3000 denarë',

  'dashboard.title': 'Pasqyra',
  'dashboard.scope': 'Komuna',
  'dashboard.allMunicipalities': 'Të gjitha komunat',
  'dashboard.bags': 'Qese të skanuara',
  'dashboard.openBags': 'Presin mbledhjen',
  'dashboard.withCollector': 'Te mbledhësi',
  'dashboard.confirmed': 'Mbërritën në kompani',
  'dashboard.contaminationRate': 'Të papastra',
  'dashboard.totalKg': 'Të ricikluara (kg)',
  'dashboard.citizens': 'Qytetarë aktivë',
  'dashboard.smartBins': 'Kontejnerë smart',
  'dashboard.fullBins': 'mbi 80% plot',
  'dashboard.today': 'Sot',
  'dashboard.scannedToday': 'të skanuara',
  'dashboard.confirmedToday': 'të konfirmuara',
  'dashboard.last7': '7 ditët e fundit',
  'dashboard.thisMonth': 'Këtë muaj',
  'dashboard.kgByType': 'Kilogramë të ricikluar sipas llojit',
  'dashboard.bagsByMonth': 'Qese të konfirmuara në muaj',
  'dashboard.topLocations': 'Lokacionet më aktive',
  'dashboard.recent': 'Aktiviteti i fundit',

  'appointments.title': 'Mbledhja e qeseve',
  'appointments.editTitle': 'Korrigjimi i mbledhjes',
  'appointments.pointsHint': 'Regjistri i pikëve sinkronizohet automatikisht me statusin.',

  'bags.title': 'Kërkesa për qese',
  'bags.close': 'Shëno të dorëzuar',
  'bags.closed': 'Kërkesa u mbyll.',

  'schedules.title': 'Terminet e mbledhjes',
  'municipalities.title': 'Komunat dhe lokacionet',
  'regions.title': 'Rajonet',
  'companies.title': 'Kompanitë e riciklimit',
  'companies.links': 'Komunat që shërben',
  'companies.linksHint': 'Kompania sheh dhe konfirmon vetëm qese nga këto komuna.',
  'recycleTypes.title': 'Llojet e mbeturinave',
  'recycleTypes.translations': 'Përkthimet',
  'recycleTypes.translationsTitle': 'Përkthimet sipas rajonit',
  'recycleTypes.missing': 'Pa përkthim – lloji nuk do të shfaqet në aplikacion për këtë rajon.',
  'recycleTypes.upload': 'Ngarko imazh',

  'users.title': 'Përdoruesit',
  'users.new': 'Përdorues i ri',
  'users.edit': 'Ndrysho përdoruesin',
  'users.changeRole': 'Ndrysho rolin',
  'users.setPassword': 'Vendos fjalëkalimin',
  'users.activate': 'Aktivizo',
  'users.deactivate': 'Çaktivizo',
  'users.inactive': 'Joaktiv',
  'users.points': 'Pikë',
  'users.ledger': 'Historia e pikëve',
  'ptx.bag_confirmed': 'Qese e konfirmuar',
  'ptx.prize_spin': 'Rrotullim i rrotës',
  'ptx.payment': 'Pagesë',
  'users.passwordSet': 'Fjalëkalimi u vendos. Të gjitha seancat e përdoruesit u mbyllën.',
  'users.roleChanged': 'Roli u ndryshua.',

  'rewards.title': 'Pikët dhe pagesat',
  'rewards.rankList': 'Renditja',
  'rewards.spins': 'Rrotullimet',
  'rewards.payments': 'Pagesat',
  'rewards.newPayment': 'Pagesë e re',
  'rewards.reverse': 'Anulo',
  'rewards.confirmReverse': 'Të anulohet pagesa? Regjistrimi fshihet dhe pikët i kthehen përdoruesit (një kopje mbetet në ditar).',
  'rewards.wonOnly': 'Vetëm fitimet',
  'rewards.pickUser': 'Zgjidhni një përdorues nga renditja',
  'prizeBudgets.title': 'Buxheti i çmimeve',

  'smartBins.title': 'Kontejnerë smart',
  'smartBins.keyTitle': 'Çelësi i pajisjes',
  'smartBins.keyText': 'Vendoseni këtë çelës në pajisje (koka X-Device-Key ose fusha SecretKey). Rrjedh nga SMARTBIN_KEY_SECRET: nëse ndryshon ai sekret, të gjitha pajisjet marrin çelësa të rinj.',
  'smartBins.reports': 'Raportet',
  'smartBins.ok': 'Sukses',
  'smartBins.failed': 'Dështoi',

  'qr.title': 'Kodet QR për qese',
  'qr.count': 'Numri i kodeve',
  'qr.kind': 'Lloji',
  'qr.generate': 'Gjenero',
  'qr.print': 'Printo',
  'qr.hint': 'Kodet janë të nënshkruara dhe nuk mund të shpiken. Kodet standarde vlejnë një herë; të veçantat janë për lokacione fikse.',

  'audit.title': 'Ditari i ndryshimeve',
  'audit.filter': 'Filtro sipas veprimit',
  'users.active': 'Aktiv',
  'users.lockedUntil': 'I bllokuar deri më {date}',
  'smartBins.showKey': 'Çelësi i pajisjes',
  'smartBins.noKeySecret': 'SMARTBIN_KEY_SECRET nuk është vendosur në server: pajisjet mund të raportojnë vetëm me sekretin e vjetër të përbashkët.',
  'municipalities.specialHint': 'Lokacionet speciale (të kompanive) kanë id negative në bazë dhe nuk krijohen nga paneli.',
};
